import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { AppConfig } from '../../../app.config';

@Injectable()
export class SubmitProxyService {

  constructor(private authHttp: AuthHttp, private appConfig: AppConfig) { }

  submit(endPoint, values) {
    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.put(serverUrl + 'templatedrivenwidget/' +  endPoint.toLowerCase(), { model : this.mapToObject(values) }).toPromise();
  }

  mapToObject(values) {
    const obj = {};
    values.forEach ((v, k) => { obj[k] = v });
    return obj;
  };

}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/services/submit-proxy.service.ts